var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-6 text-center text--secondary"},[_c('p',{staticClass:"py-8 title font-weight-bold"},[_vm._v(_vm._s(_vm.contentEmpty))])])}
var staticRenderFns = []

export { render, staticRenderFns }